import { PaymentTermStateInterface } from '.';

function state(): PaymentTermStateInterface {
  return {
    paymentTerms: [],
  };
}

export default state;
